import React, { useEffect, useState, useMemo } from 'react';
import { FormGroup, Label, Form, Input, Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { useNavigate, useLocation } from 'react-router-dom';
import { exportToCSV, exportToExcel, exportToPDF } from '../utils/Exports';
import $ from 'jquery';
import moment from 'moment';
import icons from 'awesome-react-icons';
import Table from './common/Table';
const { User, Terminal } = icons;
const common = require('../utils/Common');
const envConfig = require('../config/envConfig');

const ChatBotQueries = () => {
    let navigate = useNavigate();
    const location = useLocation();
    const [allQueries, setAllQueries] = useState([]);
    const [showChatHistory, setShowChatHistory] = useState(false);
    const [chatHistory, setChatHistory] = useState([]);
    const [showComments, setShowComments] = useState(false);
    const [comments, setComments] = useState([]);
    const [customerSupportUsers, setCustomerSupportUsers] = useState([]); 
    const [totalRecords, setTotalRecords] = useState(0);
    const [chatBotAdmins, setChatBotAdmins] = useState([]);
    const [userRights, setUserRights] = useState({view: false, edit: false, delete: false, create: false});
    const [page, setPage] = useState(1);

    useEffect(() => {
        checkAccess();
    }, []);

    const showChat = (chatHistory) => {
        setChatHistory(chatHistory);   
        setShowChatHistory(!showChatHistory);
    }

    const seeComments = (comments) => {
        setComments(comments);   
        setShowComments(!showComments);
    }
    const exportData = allQueries.map(data => ({
        "Reg id": data?.user?.reg_id,
        "First Name": data.user?.first_name,
        "Middle Name": data.user?.middle_name,
        "Last Name": data.user?.last_name,
        "Email": data.user?.email,
        "Mobile No": data.user?.mobile_phone,
        "Chat Started At": data?.started_at,
        "Chat Ended At": data?.ended_at,
    }));
    const handleExportCSV = () => {
        exportToCSV(exportData, 'Query Data');
    }

    const handleExportExcel = () => {
        exportToExcel(exportData, 'Query Data');
    }

    const handleExportPDF = () => {
        exportToPDF(exportData, 'Query Data');
    }
    const checkAccess = async () => {
        let rights = await common.checkAccessRights(window.location.pathname);
        if (!rights.view) {
          alert("Access Denied");
          navigate("/");
          return;
        } else {
            setUserRights(rights);
            if (!localStorage.getItem('admin_token')) {
                navigate('/login');
            }
            getChatBotQueries();
            fetchCustomerSupportUsers();
        }
    }

    const getChatBotQueries = async (limit = 10, offset = 0, search = {}, loader = true, reset = false) => {
        if (reset) {
            setPage(1);
            offset = 0;
        } else {
            setPage(offset / limit + 1);
        }
        const filter = document.querySelector('input[name="chat-filters"]:checked')?.value;
        const status = document.querySelector('input[name="chat-filters-status"]:checked')?.value;
        let params = {
            filter: filter,
            status: status,
            service_person_id: localStorage.getItem('admin_userId'),
            'limit': limit,
            'offset': offset,
            'start_date': $('#Date-from').val(),
            'end_date': $('#Date-to').val()
        }
        let response = await common.apiRequest('post', '/admin/get-chats', params, loader);
        if (response.data.code == 'success') {
            setAllQueries(response.data.data);
            setTotalRecords(response.data.totalRecords);
            setChatBotAdmins(await common.getSystemConfig('chatbot_admins'));
        } else {
            alert(response.data.error);
        }
    }

    const fetchCustomerSupportUsers = async () => {
        let data = {
            "action": "read",
            'customer_support': 1
        }
        let response = await common.apiRequest('post', '/admin/crud-admin-users', data);
        if (response.data.code == 'success') {
            setCustomerSupportUsers(response.data.data);
        } else {
            alert(response.data.error);
        }
    }

    const handleAssignServicePerson = async (queryId, userId) => {
        if (!userId) return;
      
        const payload = {
          query_id: queryId,
          service_person_id: userId
        };
      
        const response = await common.apiRequest('post', '/admin/assign-chat-service-person', payload);
        if (response.data.code === 'success') {
          alert(response?.data?.message || 'Updated');
          getChatBotQueries(10, (page - 1) * 10, {}, true, false);
        } else {
          alert(response.data.error || 'Failed to assign');
        }
    }

    const resolveTicket = async (queryId) => {
        const payload = {
          query_id: queryId
        };
      
        const response = await common.apiRequest('post', '/admin/resolve-chat', payload);
        if (response.data.code === 'success') {
          alert(response?.data?.message || 'Resolved');
          getChatBotQueries(10, (page - 1) * 10, {}, true, false);
        } else {
          alert(response.data.error || 'Failed to assign');
        }
    }

    const addComment = async (queryId) => {
        if (!$('#'+queryId+'_comment').val()) {
            alert('Please add comment');
            return;
        }
        const payload = {
            query_id: queryId,
            comment: $('#'+queryId+'_comment').val()
        };
      
        const response = await common.apiRequest('post', '/admin/add-comment', payload);
        if (response.data.code === 'success') {
            $('#'+queryId+'_comment').val(null);
          alert(response?.data?.message || 'Resolved');
          getChatBotQueries(10, (page - 1) * 10, {}, true, false);
        } else {
          alert(response.data.error || 'Failed to assign');
        }
    }

    const columns = [
    {
        header: "Reg ID",
        accessor: "user.reg_id",
        render: row => row?.user?.reg_id || ""
    },
    {
        header: "First Name",
        accessor: "user.first_name",
        render: row => row?.user?.first_name || ""
    },
    {
        header: "Middle Name",
        accessor: "user.middle_name",
        render: row => row?.user?.middle_name || ""
    },
    {
        header: "Last Name",
        accessor: "user.last_name",
        render: row => row?.user?.last_name || ""
    },
    {
        header: "Email",
        accessor: "user.email",
        render: row => row?.user?.email || ""
    },
    {
        header: "Phone",
        accessor: "user.mobile_phone",
        render: row => row?.user?.mobile_phone || ""
    },
    {
        header: "Chat Started At",
        accessor: "started_at",
        render: row => moment(row?.started_at).format('YYYY-MM-DD HH:mm:ss')
    },
    {
        header: "Chat Ended At",
        accessor: "ended_at",
        render: row => moment(row?.ended_at).format('YYYY-MM-DD HH:mm:ss')
    },
    {
        header: "Arrange Call",
        accessor: "arrange_call",
        render: row => row?.arrange_call ? "Yes" : "No"
    },
    {
        header: "Service Person",
        accessor: "service_person",
        render: row => {
        const adminUserId = parseInt(localStorage.getItem('admin_userId'));
        const person = customerSupportUsers.find(u => u.id == row?.service_person);
        if (chatBotAdmins.includes(adminUserId)) {
            return (
            <select
                className="form-select form-select-sm"
                value={row.service_person || ''}
                onChange={(e) => handleAssignServicePerson(row._id, e.target.value)}
            >
                <option value="">Assign Service Person</option>
                {customerSupportUsers.map(user => (
                <option key={user.id} value={user.id}>
                    {user.first_name} {user.last_name}
                </option>
                ))}
            </select>
            );
        } else {
            return row?.service_person
            ? (person ? `${person.first_name} ${person.last_name}` : "Unknown")
            : (
                <button
                className="btn btn-sm btn-outline-primary"
                onClick={() => handleAssignServicePerson(row._id, localStorage.getItem('admin_userId'))}
                >
                Assign to Me
                </button>
            );
        }
        }
    },
    {
        header: "Add Comment",
        accessor: "comment",
        render: row => (
        <div>
            <textarea rows={2} cols={20} id={row?._id + '_comment'} defaultValue=""></textarea>
            <button type='button' className='btn btn-sm btn-info' onClick={() => addComment(row?._id)}>Add Comment</button>
        </div>
        )
    },
    {
        header: "See Comments",
        accessor: "comments",
        render: row => (
        <button type='button' className='btn btn-sm btn-info' onClick={() => seeComments(row?.comments || [])}>
            See Comments
        </button>
        )
    },
    {
        header: "Mark As Resolved",
        accessor: "open",
        render: row => row?.open
        ? <button type='button' className='btn btn-sm btn-success' onClick={() => resolveTicket(row._id)}>Resolve</button>
        : 'Resolved'
    },
    {
        header: "Chat History",
        accessor: "chat",
        render: row => (
        <button type='button' className='btn btn-sm btn-primary' onClick={() => showChat(row?.chat || [])}>
            See History
        </button>
        )
    }
    ];

      

    return (
        <>
            <div className='row'>
                <div className='col-md-12 m-2'>
                    <h1>Chatbot Queries</h1>
                </div>
            </div>
            <div className="col-md-12">
                <Form className='row'>
                    <FormGroup className='col-md-4 row'>
                        <Label className="col-md-2 col-form-label" for="Date-from">From:</Label>
                        <Input type='date' defaultValue={moment().startOf('month').format('YYYY-MM-DD')}   onChange={(e) => getChatBotQueries()}  className="form-control col-md-5" id="Date-from" name="Date-from"></Input>
                    </FormGroup>
                    <FormGroup className='col-md-4 row'>
                        <Label className="col-md-2 col-form-label" for="Date-to">To:</Label>
                        <Input type='date' defaultValue={moment().endOf('month').format('YYYY-MM-DD')}   onChange={(e) => getChatBotQueries()}  className="form-control col-md-5" id="Date-to" name="Date-to"></Input>
                    </FormGroup>
                </Form>
            </div>
            <div className="mb-4">
                <button className='btn button-product mr-2' onClick={handleExportCSV}>Export to CSV</button>
                <button className='btn button-product mr-2' onClick={handleExportExcel}>Export to Excel</button>
                <button className='btn button-product' onClick={handleExportPDF}>Export to PDF</button>
            </div>
            <div className='row'>
                <div className='col-12 m-2'>
                    <label>
                        <input type='radio' name='chat-filters' id="all-chats" value="all" onChange={() => getChatBotQueries()} defaultChecked /> All Chats
                        <input type='radio' name='chat-filters' id="assigned-to-me" value="assigned" className='ml-2' onChange={() => getChatBotQueries()} /> Assigned To Me
                    </label>
                    <br/>
                    <label>
                        <input type='radio' name='chat-filters-status' id='all' value="all" onChange={() => getChatBotQueries()}  defaultChecked /> All
                        <input type='radio' name='chat-filters-status' id="open" value="open" className='ml-2' onChange={() => getChatBotQueries()} /> Open
                        <input type='radio' name='chat-filters-status' id="closed" value="closed" className='ml-2' onChange={() => getChatBotQueries()} /> Closed
                    </label>
                </div>
            </div>

            <div className='row'>
                <div className='col-12 m-2'>
                    <Table 
                        columns={columns}
                        data={allQueries}
                        totalRecords={totalRecords}
                        pageSize={10}
                        currentPage={page}
                        onPageChange = {(limit, offset, search, reset) =>{
                            getChatBotQueries(limit, offset, search, true, reset);
                        }}
                    />
                </div>
            </div>

            <Modal isOpen={showChatHistory} toggle={() => showChat([])} size="lg" centered scrollable>
                <ModalHeader toggle={() => showChat([])}>Chat History</ModalHeader>
                <ModalBody>
                    <div className="chat-container">
                        {chatHistory.map((msg, index) => (
                            <div
                                key={index}
                                className={`d-flex mb-3 ${msg.sender === 'user' ? 'justify-content-end' : 'justify-content-start'}`}
                            >
                                {msg.sender === 'bot' && <div className="icon-circle me-2">B</div>}
                                <div className={`p-3 rounded ${msg.sender === 'bot' ? 'bg-light text-dark' : 'bg-info text-white'}`} style={{ maxWidth: '70%' }}>
                                    <div className="small fw-bold mb-1">
                                        {msg.sender === 'bot' ? 'Bot' : 'User'}
                                    </div>
                                    <div>{msg.message}</div>
                                    <div className="small text-muted mt-1">{new Date(msg.time).toLocaleString()}</div>
                                </div>
                                {msg.sender === 'user' && <div className="icon-circle ms-2">U</div>}
                            </div>
                        ))}
                    </div>
                </ModalBody>
                <ModalFooter>
                    <button className="btn btn-secondary" onClick={() => showChat([])}>
                        Close
                    </button>
                </ModalFooter>
            </Modal>

            <Modal isOpen={showComments} toggle={() => seeComments([])} size="lg" centered scrollable>
                <ModalHeader toggle={() => seeComments([])}>Comments</ModalHeader>
                <ModalBody>
                    <div className="chat-container">
                        {comments.length > 0 && comments.map((msg, index) => (
                            <div
                                key={index}
                                className='justify-content-start'
                            >
                                <div className="icon-circle me-2">SP</div>
                                <div className='p-3 rounded bg-light text-dark' style={{ maxWidth: '70%' }}>
                                    <div className="small fw-bold mb-1">
                                        Service Person
                                    </div>
                                    <div>{msg.comment}</div>
                                    <div className="small text-muted mt-1">{new Date(msg.time).toLocaleString()}</div>
                                </div>
                            </div>
                        ))}

                        { comments.length == 0 && 
                            <div>No Comments</div>
                        }
                    </div>
                </ModalBody>
                <ModalFooter>
                    <button className="btn btn-secondary" onClick={() => seeComments([])}>
                        Close
                    </button>
                </ModalFooter>
            </Modal>
        </>
    )
}

export default ChatBotQueries;